import { WORKSPACE_TAG_STACK_MAX, type WorkspaceTagDot } from '@/lib/workspace-tag-stack'
import { cn } from '@/lib/utils'

export type WorkspaceTagStackProps = {
  tags: WorkspaceTagDot[]
  className?: string
  'data-testid'?: string
}

/**
 * Overlapping workspace color dots for multi-tagged chats.
 * `tags` is front-first: the first item eclipses the rest.
 */
export function WorkspaceTagStack({
  tags,
  className,
  'data-testid': testId,
}: WorkspaceTagStackProps) {
  if (tags.length === 0) return null

  const visible = tags.slice(0, WORKSPACE_TAG_STACK_MAX)
  const title = tags.map((t) => t.name).join(', ')
  const backFirst = [...visible].reverse()

  return (
    <span
      className={cn('inline-flex items-center', className)}
      title={title}
      aria-label={title}
      data-testid={testId}
    >
      {backFirst.map((tag, index) => (
        <span
          key={tag.id}
          className="relative block h-2 w-2 shrink-0 rounded-full"
          style={{
            backgroundColor: tag.color ?? 'currentColor',
            marginLeft: index === 0 ? 0 : -5,
            zIndex: index + 1,
            boxShadow: '0 0 0 1px hsl(var(--sidebar-background))',
          }}
          aria-hidden
        />
      ))}
    </span>
  )
}
